import React from "react";
import { TeaserSliderOptionsType } from "@/types/ModuleOptionsType";
import { Modul_Teaser_Slider } from "../../wp/types/acf-module-types";
import { useSublinesVisibility } from "../../hooks/useSublinesOverlinesVisibility";
import { Section } from "../../components/Section/Section";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@aleksundshantu/aunds-utils-react/primitives/carousel";
import {
  TeaserCard,
  TeaserSliderElementType,
} from "../../components/TeaserCard/TeaserCard";
import { checkModuleIsHidden } from "@/utils/checkModuleIsHidden";
import { columnSize } from "@/utils/layout/columnSize";
import { Headline } from "@/components/Headline/Headline";
import { FadeInUp } from "../../components/Animation/ScrollAnimation";
import { SliderScrollBar } from "@/components/Pagination/SliderScrollBar";
import useWindowSize from "@/hooks/useWindowSize";
import { SliderControls } from "@/components/Pagination/SliderControls";
import styles from "./TeaserSlider.module.scss";
import { FileType } from "@/types/baseTypes";

export type TeaserSliderModuleType = Modul_Teaser_Slider;

interface TeaserSliderModuleProps {
  data: TeaserSliderModuleType;
  teaserSliderOptions: TeaserSliderOptionsType;
  teaserSliderData: TeaserSliderElementType[];
  metalCsvFile: FileType;
}

const TeaserSliderModule = ({
  data,
  teaserSliderOptions,
  teaserSliderData,
  metalCsvFile,
}: TeaserSliderModuleProps) => {
  const { headline, headline_html_tag, overline, subline, type } =
    data.teaser_slider;

  const {
    background_color_class,
    id,
    module_width,
    section_margin_class,
    section_padding_class,
    headline_text_align_class,
  } = data.layout;

  const {
    show_overline_subline,
    media_format,
    card_width,
    slider_options: { has_autoplay },
    columns,
  } = teaserSliderOptions;

  const { width } = useWindowSize();
  const { showOverline, showSubline } = useSublinesVisibility(
    show_overline_subline,
  );

  {
    /* jscpd:ignore-start */
  }
  //! check if module is hidden
  const isHidden = checkModuleIsHidden(data.settings);
  if (isHidden) {
    return null;
  }
  {
    /* jscpd:ignore-end */
  }

  const subtext = showSubline ? subline : showOverline ? overline : "";

  const CarouselJSX = (
    <>
      <Carousel dragFree autoplay={has_autoplay} align={"start"}>
        <div className={styles["carousel-box"]}>
          {width >= 768 && (
            <SliderControls className={styles["slider-side-controls"]} />
          )}

          <CarouselContent
            outerPadding="16px"
            spacing="2rem"
            className={styles["content-wrapper"]}
          >
            {teaserSliderData.map((element, i) => (
              <CarouselItem
                key={i}
                itemWidth={
                  card_width
                    ? card_width.reduce(
                        (itemWidth, currentWidth) => {
                          return {
                            ...itemWidth,
                            ...(currentWidth.breakpoint && {
                              [currentWidth.breakpoint]:
                                (currentWidth.number_of_cols / 12) * 100 + "%",
                            }),
                          };
                        },
                        { mobile: "100%" },
                      )
                    : undefined
                }
              >
                <TeaserCard
                  type={type}
                  element={element}
                  teaserSliderOptions={teaserSliderOptions}
                  moduleWidth={module_width}
                  mediaFormat={media_format}
                  heading_level={headline ? 3 : 2}
                  metalCsvFile={metalCsvFile}
                />
              </CarouselItem>
            ))}
          </CarouselContent>

          <SliderScrollBar
            className={`${styles["slider-pagination"]}`}
            showControls={width < 768}
          />
        </div>
      </Carousel>
    </>
  );

  return (
    <Section
      id={id}
      disableClip
      // disableColumns={module_width !== "narrow-frame"}
      columnsClassName="is-centered is-multiline"
      className={`${styles["teaser-slider"]} teaser-slider ${background_color_class} ${section_margin_class} ${section_padding_class} ${module_width === "frameless" ? styles["padding-control"] : ""}`}
    >
      <div
        className={`column ${module_width === "narrow-frame" ? columnSize(columns) : "is-12"}`}
      >
        {(headline || subtext) && (
          <FadeInUp>
            <Headline
              headline_html_tag={headline_html_tag}
              headline={headline}
              extraClass={headline_text_align_class}
              overline={showOverline ? subtext : ""}
              subline={showSubline ? subtext : ""}
              // wrapInSection={module_width === "frameless"}
              disableAnimation
            />
          </FadeInUp>
        )}
        <FadeInUp>{CarouselJSX}</FadeInUp>
      </div>
    </Section>
  );
};

export default TeaserSliderModule;
